import TransmedFormSection from "../../../../dtos/transmed/process/form/section";
import TransmedRegistration from "../../../../dtos/transmed/process/registration/registration";
import TransmedProcessSlide from "./slide";

type PropsType = {
  sections: TransmedFormSection[];
  registration: TransmedRegistration;
};

function TransmedProcessSubmitted(props: PropsType) {
  return (
    <TransmedProcessSlide>
      <h3>Înscrierea ta a fost înregistrată</h3>
      <span>
        În cel mai scurt timp îți vom verifica documentele și confirma
        înscrierea
      </span>
      <span className="label">
        Punctajul final va fi diferit de cel estimativ, întrucât acesta este
        calculat în funcție de cel mai mare punctaj obținut de un oarecare
        candidat, pentru fiecare secțiune.
      </span>
      <div
        style={{
          marginTop: "var(--gap-big)",
          display: "flex",
          flexDirection: "column",
          alignSelf: "stretch",
          alignItems: "center",
          gap: "var(--gap-medium)",
        }}
      >
        <h4>Punctaj Estimativ</h4>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            gap: "var(--gap-small)",
            alignSelf: "stretch",
          }}
        >
          {props.sections.map((section) => (
            <div
              key={section.id}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <b style={{ textAlign: "center" }}>{section.title}</b>
              <h1 style={{ color: "var(--color-fasmr-blue)" }}>
                {section.subsections.reduce((acc, ss) => {
                  let sum = 0;

                  for (const f of ss.fields) {
                    const rf = props.registration.fields.find(
                      (val) => val.field === f.id
                    );
                    if (rf) {
                      sum += rf.quantity * f.points;
                    }
                  }

                  return acc + sum;
                }, 0)}
              </h1>
            </div>
          ))}
        </div>
      </div>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessSubmitted;
